import { render, staticRenderFns } from "./PalletReceiptsLayout.vue?vue&type=template&id=59a6d37c"
import script from "./PalletReceiptsLayout.vue?vue&type=script&lang=js"
export * from "./PalletReceiptsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports